import { html } from "lit";

/** Cursor-style circular context meter (SVG ring). */
export function renderContextUsageRing(percent: number | null, options?: { size?: number }) {
  const size = options?.size ?? 32;
  if (percent == null) {
    return html`
      <span class="context-usage-ring context-usage-ring--empty" aria-hidden="true">
        <span class="context-usage-ring__track"></span>
      </span>
    `;
  }
  const radius = 14;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  return html`
    <span
      class="context-usage-ring ${percent >= 85 ? "context-usage-ring--high" : ""}"
      role="meter"
      aria-valuenow=${percent}
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: ${size}px; height: ${size}px;"
    >
      <svg viewBox="0 0 36 36" width=${size} height=${size} aria-hidden="true">
        <circle
          class="context-usage-ring__track"
          cx="18"
          cy="18"
          r=${radius}
          fill="none"
          stroke-width="3"
        ></circle>
        <circle
          class="context-usage-ring__fill"
          cx="18"
          cy="18"
          r=${radius}
          fill="none"
          stroke-width="3"
          stroke-dasharray=${`${circumference} ${circumference}`}
          stroke-dashoffset=${offset}
          transform="rotate(-90 18 18)"
        ></circle>
      </svg>
    </span>
  `;
}
